module.exports = __webpack_public_path__ + "img/icon_love.9028ce42.png";